import { render, staticRenderFns } from "./newsType.vue?vue&type=template&id=725d4806&scoped=true&"
import script from "./newsType.vue?vue&type=script&lang=ts&"
export * from "./newsType.vue?vue&type=script&lang=ts&"
import style0 from "./newsType.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsType.vue?vue&type=style&index=1&id=725d4806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725d4806",
  null
  
)

export default component.exports